import { render, staticRenderFns } from "./WritingBlankType3Form.vue?vue&type=template&id=06e6c64b&"
import script from "./WritingBlankType3Form.vue?vue&type=script&lang=js&"
export * from "./WritingBlankType3Form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports